// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rounded-2xl{background:#fff;box-shadow:0 2.49606px 39.937px 12.4803px rgba(0,0,0,.05)}.hero{background-size:cover;background-position:50%;background-repeat:no-repeat;height:125px;margin-top:65px}@media (min-width:768px){.hero{height:280px;margin-top:90px}}", ""]);
// Exports
module.exports = exports;
